module.exports = __webpack_public_path__ + "media/images/icons/x_logo_valid-ce586ef99d91c9d6633da10af2b32a28.svg";